module.exports = "<div *ngFor=\"let errorMessage of errorMessages\" class=\"ui-message ui-messages-error ui-corner-all\">\n    {{errorMessage}}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/validation-messages/validation-messages.component.html
// module id = ./src/app/core/validation-messages/validation-messages.component.html
// module chunks = main